import ILabel from "../../interfaces/label";
import * as React from "react";

export const Label = (props: ILabel) => {
  return (
    <>
      <label className={props.className}>{props.text}</label>
    </>
  );
};
